import { languageService } from "../../../../Language/language.service";

export const hosActivityTypeFormSchema = {
  title: "Add New Activity Type",
  id: "hosActivityTypeFormSchema",
  returnOnlyEnabledFields: false,
  stateTitle: {
    create: languageService("Add New Activity Type"),
    edit: languageService("Edit Activity Type"),
    delete: languageService(`Are you sure you want to delete the following Activity Type?`),
  },
  sections: [
    {
      id: "generalInfoSection",
      disabledStates: ["delete"],
      fields: [
        {
          id: "description", // required
          labelValue: languageService("Description"),
          required: true,
          col: 12,
        },
        {
          id: "value", // required
          labelValue: languageService("Activty"),
          required: true,
          col: 12,
        },
        {
          id: "code", // required
          labelValue: languageService("Code"),
          maxLength: 2,
          col: 12,
        },
        {
          id: "group", // required
          labelValue: languageService("Group"),
          required: true,
          col: 12,
        },
        {
          id: "isOffDuty",
          type: "checkbox",
          labelValue: languageService("Is Off Duty"),
          showFieldsOnCertainValue: [{ values: [true], targetIds: ["serviceCodes"], inverse: true }],
          col: 12,
        },
        {
          id: "serviceCodes", // required
          type: "multiSelect",
          selectOptions: [],
          labelValue: languageService("Service Types"),
          required: true,
          col: 12,
        },
      ],
    },
    {
      id: "footerActionsSection",
      fields: [
        {
          id: "addActivityType",
          type: "button",
          labelValue: languageService("Add"),
          action: "submit",
          callback: "addActivityType",
          position: "footer",
          hiddenStates: ["edit", "delete"],
          col: 6,
        },
        {
          id: "confirmDeleteActivityType",
          type: "button",
          labelValue: languageService("Confirm"),
          action: "submit",
          callback: "confirmDeleteActivityType",
          position: "footer",
          hiddenStates: ["create", "edit"],
          col: 6,
        },
        {
          id: "updateActivityType",
          type: "button",
          labelValue: languageService("Update"),
          action: "submit",
          callback: "updateActivityType",
          position: "footer",
          hiddenStates: ["create", "delete"],
          col: 6,
        },
        {
          id: "cancelDialog", // required
          type: "button", // required
          labelValue: languageService("Cancel"),
          action: "cancel",
          position: "footer",
          col: 6,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/HoursOfService/ActivitiesList/schemas/hosActivityTypeFormSchema.js